import React from 'react';
import './ProgressBar.css';

function ProgressBar({ progress, current, total }) {
  return (
    <div className="progress-container">
      <div className="progress-info">
        <span className="progress-label">진행률</span>
        <span className="progress-count">{current} / {total}</span>
      </div>
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}

export default ProgressBar;